import React, { useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";

const Victim = ({ onNext,onQuestion }) => {

  const [isPlaying, setIsPlaying] = useState(false); // State to track audio play status

  const audioRef = useRef(null);
  const handleOkClick = (e) => {
    e.preventDefault();
    onNext(6);
    onQuestion(7)
    localStorage.setItem('victim', JSON.stringify('victim'));
    };

    const toggleAudio = (e) => {
      e.preventDefault()
      if (audioRef.current) {
        if (isPlaying) {
          audioRef.current.pause(); // Pause the audio
          setIsPlaying(false);
        } else {
          audioRef.current.play(); // Play the audio
          setIsPlaying(true);
        }
      }
    };
  
    const handleAudioEnd = () => {
      setIsPlaying(false); // Reset to show Play button when audio ends
    };
  return (
    <div className="question">
      <div style={{ display: "flex",justifyContent:'center' }}>
        <div style={{ display: "flex",flexDirection:'column', alignItems: "center" }}>
        <div style={{ display: "flex",justifyContent:'center' }}>
          <h2 htmlFor="lose-money">Basic information of the victim</h2>
          <button
            onClick={toggleAudio}
            className="audio-button"
          >
         {/* <FaPlay /> */}
         {isPlaying ? <FaPause /> : <FaPlay />}
          </button>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd}>
            <source src="audio\victim.mp3" type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <p className="victim-para">Answer the set of questions about the victim.</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button type="button" className="continue-btn" onClick={handleOkClick}>
              Continue
            </button>
            {/* <p className="enter-text">
              press <strong>Enter ↵</strong>
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Victim;
